<template>
    <iframe
        id="joinedClub"
        class="iframeSel"
        :src="ruta"
        @load="loadIframe"
        :style="{ width: '100%', minHeight: `${windowHeight}px`, heigh: 'auto' }"
    ></iframe>
</template>

<script>
import { mapState } from 'vuex';
import RegistrationService from "@/services/RegistrationService";
import OrganizationService from "@/services/OrganizationService";

export default {
    data: () => ({
        oId: 0,
        uId: 0,
        token: '',
        windowHeight: 0,
        onLoad: false,
        registrationObj: {
            step: 1,
            promoters: [],
            promoterSel: {},
            events:[],
            eventSel: null,
            participants: [],
            partsSel: [],
            classE: [],
            brandsE: [],
            userId: 0,
            spectators: [],
            spectatorsSel: [],
            practicesSel: []
        },
        userOrgId: 0
    }),
    computed: {
        ...mapState({
            ruta(state) {
                let url = '/admin/joinedclub?';
                    url = url + this.oId + "&dtm=true";

                return state.env.get('VUE_APP_ROOT') + url;
            },
            language(state) {
                return { languageId: state.session.languageId, languageCode: state.session.languageCode };
            }
        })
    },
    created() {
        this.oId = this.$route.query.oId;
    },
    mounted() {
        this.uId = this.$route.query.uId;
        this.token = this.$route.query.token;
        this.windowHeight = window.innerHeight;         
        this.getOrganization();
    },
    watch: {
        language(val) {
            if(this.onLoad && val.languageId)
                document.getElementById("joinedClub").contentWindow.updateLang(val.languageId);
        }
    },
    methods: {
        getOrganization() {
            OrganizationService.getOrganizationPromoters(this.oId).then(async (resp) => {
                if (resp && resp.data && resp.data.success == 1)
                {
                    let data = resp.data.message;
                    this.userOrgId = data && data.usersID ? data.usersID : 0;
                    this.getPromoters();
                }
            });
        },
        async getPromoters() {
            const resp = await RegistrationService.getPromoterListDays(30);
            
            if (!resp?.data?.success) {
                return;
            }

            if (this.userOrgId <= 0) {
                return;
            }

            const promoter = resp.data.message.find(p => p.userID === this.userOrgId);
            
            if (!promoter) {
                this.registrationObj.step = 1;
                this.$store.commit('SET_DATA_STEP', this.registrationObj);
                return;
            }

            const eventResp = await RegistrationService.getEventsByPromoter({
                id: this.userOrgId,
                days: 500,
                limit: 50,
                user: 0,
                bGetEventDescription: false
            });

            const events = eventResp.data.message;
            
            this.registrationObj = {
                ...this.registrationObj,
                eventSel: events[0],
                events: events,
                promoterSel: promoter,
                step: 2
            };
            this.$store.commit('SET_DATA_STEP', this.registrationObj);
        },
        loadIframe() {
            this.onLoad= true; 
            this.$emit('resizeIframe'); 
            this.$emit('changeLoadingStep', false);
        },
    }
}
</script>